import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import CountUp from "react-countup";
import { CSVLink } from "react-csv";
import { notifyError, notifySuccess } from "../../../helpers/Notify";
import swal from "sweetalert";
import { IMAGES } from "../../constant/theme";
import {
  useGetAllCallOutTaskQuery,
  usePutCallOutTaskMutation,
} from "../../../features/callOutTask/callOutTaskApiSlice";
import { selectCurrentUser } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";

const headersTitle = [
  { label: "Employee ID", key: "id" },
  { label: "Invoice", key: "invid" },
  { label: "Status", key: "status" },
  { label: "Name", key: "title" },
  { label: "Start Date", key: "startdate" },
  { label: "End Date", key: "enddate" },
  { label: "Priority", key: "select" },
];

function tConvert(time) {
  // Check correct time format and split into components
  time = time?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}

const CallOutTask = ({ handleTask, user }) => {
  const userInfo = useSelector(selectCurrentUser);

  const {
    data: callOutTask = [],
    refetch,
    isSuccess,
  } = useGetAllCallOutTaskQuery();
  const [updateTask] = usePutCallOutTaskMutation();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [filteredTasks, setFilteredTasks] = useState(callOutTask);

  const csvlink = {
    headers: headersTitle,
    data: filteredTasks,
    filename: "csvfile.csv",
  };

  const [taskInProgress, setTaskInProgress] = useState(0);
  const [taskTesting, setTaskTesting] = useState(0);
  const [taskComplete, setTaskComplete] = useState(0);
  const [taskPending, setTaskPending] = useState(0);

  const cardCounter = [
    { number: taskInProgress, countText: "purple", title: "In Progress" },
    { number: taskComplete, countText: "success", title: "Complete" },
    { number: taskPending, countText: "danger", title: "Pending" },
  ];

  useEffect(() => {
    let inProgress = 0;
    let testing = 0;
    let complete = 0;
    let pending = 0;

    callOutTask?.forEach((task) => {
      if (task.status === "In Progress") inProgress += 1;
      if (task.status === "Testing") testing += 1;
      if (task.status === "Complete") complete += 1;
      if (task.status === "Pending") pending += 1;
    });
    setTaskInProgress(inProgress);
    setTaskTesting(testing);
    setTaskComplete(complete);
    setTaskPending(pending);
  }, [callOutTask, isSuccess, refetch]);

  useEffect(() => {
    const filtered = callOutTask.filter((task) => {
      const searchLower = search.toLowerCase();
      const customerFirstName =
        task?.agreement?.customer?.firstname?.toLowerCase() || "";
      const customerLastName =
        task?.agreement?.customer?.lastname?.toLowerCase() || "";
      const status = task?.status?.toLowerCase() || "";
      const priority = task?.priority?.toLowerCase() || "";
      const startDate = task?.startDate
        ? formatDate(task?.startDate).toLowerCase()
        : "";
      const endDate = task?.endDate
        ? formatDate(task?.endDate).toLowerCase()
        : "";
      const assignee = task?.user
        ? (task.user.firstName + " " + task.user.lastName).toLowerCase()
        : "";
      const preferredTime = task?.preferredTime?.toLowerCase() || "";
      const invoiceId = task?.quotaion?.invoiceId?.toString() || "";

      return (
        customerFirstName.includes(searchLower) ||
        customerLastName.includes(searchLower) ||
        status.includes(searchLower) ||
        priority.includes(searchLower) ||
        startDate.includes(searchLower) ||
        endDate.includes(searchLower) ||
        assignee.includes(searchLower) ||
        preferredTime.includes(searchLower) ||
        invoiceId.includes(searchLower)
      );
    });

    setFilteredTasks(filtered);
  }, [search, callOutTask]);

  const recordsPage = 13;
  const [currentPage, setCurrentPage] = useState(1);

  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const records = filteredTasks.slice(firstIndex, lastIndex);
  const npage = Math.ceil((filteredTasks.length || 0) / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  function prePage() {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== npage) setCurrentPage(currentPage + 1);
  }

  const handleSelect = (task, value) => {
    if (task.status === "Complete") {
      notifyError("Task Completed");
      return;
    }
    const updatedTask = { ...task, priority: value };

    updateTask({ callOutTaskId: updatedTask.callOutTaskId, updatedTask })
      .unwrap()
      .then(() => {
        notifySuccess("task updated successfully");
        refetch();
      })
      .catch((error) => console.error("Update failed", error));
  };

  const handleInvoice = (task) => {
    if (task?.invoiceId == null) {
      navigate(
        "/" +
          userInfo?.role.toLowerCase() +
          "/invoices/callout/create/" +
          task?.callOutTaskId
      );
    } else {
      navigate(
        "/" +
          userInfo?.role?.toLowerCase() +
          "/invoices/callout/view/" +
          task?.invoiceId
      );
    }
  };

  const handleDetail = (task) => {
    navigate(
      "/" +
        user.role.toLowerCase() +
        "/callout-services/view/" +
        task?.callOutTaskId
    );
  };

  function formatDate(dateString) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return `${day < 10 ? "0" + day : day} ${months[monthIndex]} ${year}`;
  }

  const employessData = (data) => {
    const employessName = data?.map((item) => {
      try {
        return JSON.parse(item);
      } catch (error) {
        return item;
      }
    });

    return employessName?.map((employee) => employee.label);
  };

  const [statusPriority, setStatusPriority] = useState(records);

  const handleAction = (task, value) => {
    if (task.status === "Complete") {
      notifyError("Task already Completed");
      return;
    }
    const updatedTask = { ...task, status: value };

    updateTask({ callOutTaskId: updatedTask.callOutTaskId, updatedTask })
      .unwrap()
      .then(() => {
        notifySuccess("task updated successfully");
        refetch();
      })
      .catch((error) => console.error("Update failed", error));
  };

  const SweetAlert = () =>
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
      } else {
        swal("Your data is safe!");
      }
    });

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row task">
                  {cardCounter.map((item, index) => (
                    <div className="col-xl-2 col-sm-4 col-6" key={index}>
                      <div className="task-summary">
                        <div className="d-flex align-items-baseline">
                          <CountUp
                            className={`mb-0 fs-28 fw-bold me-2 text-${item.countText}`}
                            end={item.number}
                            duration={5}
                          />
                          <h6 className="mb-0">{item.title}</h6>
                        </div>
                        <p>Tasks assigned</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects task-table">
                  <div className="tbl-caption d-flex justify-content-between align-items-center">
                    <h4 className="heading mb-0">Call Out Task</h4>
                    <div className="row task mb-3">
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search by name"
                          className="form-control me-2"
                        />

                        <CSVLink
                          {...csvlink}
                          className="btn btn-primary light btn-sm me-2"
                          style={{
                            whiteSpace: "nowrap",
                            padding: "0.775rem 1.75rem",
                          }}
                        >
                          <i className="fa-solid fa-file-excel me-2" /> Export
                          Report
                        </CSVLink>
                        <button
                          className="btn btn-primary light btn-sm"
                          onClick={handleTask}
                          style={{
                            whiteSpace: "nowrap",
                            padding: "0.775rem 1.75rem",
                          }}
                        >
                          Task
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    id="task-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyeestbl2"
                      className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Assignee Lead</th>
                          <th>Assigned To</th>
                          <th>Preferred Time</th>
                          <th>Priority</th>
                          <th className="">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records?.map((task, index) => (
                          <tr key={index}>
                            <td>
                              <span>{index + 1}</span>
                            </td>
                            <td>
                              <span>
                                {" "}
                                {task &&
                                  (task?.agreement?.customer?.prefixName != null
                                    ? task?.agreement?.customer?.prefixName
                                    : "") +
                                    " " +
                                    task?.agreement?.customer?.firstname +
                                    " " +
                                    task?.agreement?.customer?.lastname}
                              </span>
                            </td>
                            <td style={{ zIndex: "200px" }}>
                              {user?.Role?.permissions?.includes(
                                "callout-services/edit/:callOutId"
                              ) ? (
                                task?.status == "Complete" ? (
                                  <button
                                    as="div"
                                    className="py-1 px-2 rounded bg-success"
                                    style={{
                                      pointerEvents: "none",
                                      cursor: "default",
                                      border: "none",
                                      color: "white",
                                    }}
                                  >
                                    Complete
                                  </button>
                                ) : (
                                  <Dropdown className="task-dropdown-2">
                                    <Dropdown.Toggle
                                      as="div"
                                      className={task.status}
                                    >
                                      {task.status}
                                    </Dropdown.Toggle>
                                    {user?.Role?.permissions?.includes(
                                      "task/edit/:taskId"
                                    ) && (
                                      <Dropdown.Menu className="task-drop-menu">
                                        {task?.status != "In Progress" && (
                                          <Dropdown.Item
                                            onClick={() =>
                                              handleAction(task, "In Progress")
                                            }
                                          >
                                            In Progress
                                          </Dropdown.Item>
                                        )}
                                        {task?.status != "Pending" && (
                                          <Dropdown.Item
                                            onClick={() =>
                                              handleAction(task, "Pending")
                                            }
                                          >
                                            Pending
                                          </Dropdown.Item>
                                        )}
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleAction(task, "Complete")
                                          }
                                        >
                                          Complete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    )}
                                  </Dropdown>
                                )
                              ) : (
                                <button
                                  as="div"
                                  className={`py-1 px-2 rounded 
                                    ${
                                      task.status === "Complete"
                                        ? "bg-success text-white"
                                        : task.status === "Pending"
                                        ? "bg-warning text-dark"
                                        : task.status === "In Progress"
                                        ? "bg-info text-white"
                                        : ""
                                    }`}
                                  style={{
                                    pointerEvents: "none",
                                    cursor: "default",
                                    border: "none",
                                    color: "white",
                                  }}
                                >
                                  {task?.status}
                                </button>
                              )}
                            </td>
                            <td>
                              <span>
                                {new Date(task?.startDate).toLocaleDateString()}
                              </span>
                            </td>
                            <td>
                              {task?.status === "Complete"
                                ? new Date(task?.updatedAt).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true, // This will format the time in AM/PM format
                                    }
                                  )
                                : ""}
                            </td>
                            <td className="avatar-list avatar-list-stacked">
                              <div
                                key={index}
                                className="avatar-container"
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                                onMouseEnter={(e) => {
                                  const avatar =
                                    e.currentTarget.querySelector(".label");
                                  if (avatar) avatar.style.opacity = "1";
                                }}
                                onMouseLeave={(e) => {
                                  const avatar =
                                    e.currentTarget.querySelector(".label");
                                  if (avatar) avatar.style.opacity = "0";
                                }}
                              >
                                <img
                                  src={IMAGES.contact6}
                                  className="avatar avatar-md rounded-circle"
                                  alt=""
                                />
                                <div
                                  className="label"
                                  style={{
                                    position: "absolute",
                                    top: "-30px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    opacity: "0",
                                    backgroundColor: "#fff",
                                    padding: "5px",
                                    borderRadius: "5px",
                                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
                                  }}
                                >
                                  {task?.user?.firstName +
                                    " " +
                                    task?.user?.lastName}
                                </div>
                              </div>
                              <div
                                className="ml-10"
                                style={{
                                  display: "inline-block",
                                  marginLeft: "15px",
                                }}
                              >
                                {task?.user?.firstName +
                                  " " +
                                  task?.user?.lastName}
                              </div>
                            </td>
                            <td className="avatar-list avatar-list-stacked">
                              {employessData(task?.employee)?.map(
                                (label, index) => (
                                  <div
                                    key={index}
                                    className="avatar-container"
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                    onMouseEnter={(e) => {
                                      const avatar =
                                        e.currentTarget.querySelector(".label");
                                      if (avatar) avatar.style.opacity = "1";
                                    }}
                                    onMouseLeave={(e) => {
                                      const avatar =
                                        e.currentTarget.querySelector(".label");
                                      if (avatar) avatar.style.opacity = "0";
                                    }}
                                  >
                                    <img
                                      src={IMAGES.contact6}
                                      className="avatar avatar-md rounded-circle"
                                      alt=""
                                    />
                                    <div
                                      className="label"
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        opacity: "0",
                                        backgroundColor: "#fff",
                                        padding: "5px",
                                        borderRadius: "5px",
                                        boxShadow:
                                          "0px 0px 5px rgba(0, 0, 0, 0.3)",
                                      }}
                                    >
                                      {label}
                                    </div>
                                  </div>
                                )
                              )}
                            </td>
                            <td>
                              {task?.preferredTime
                                ? tConvert(task?.preferredTime)
                                : "-"}
                            </td>
                            <td className="">
                              <Dropdown className="task-dropdown-2">
                                <Dropdown.Toggle
                                  as="div"
                                  className={task.select}
                                  // disabled = {true}
                                >
                                  {task.priority}
                                </Dropdown.Toggle>
                                {task?.status != "Complete" && (
                                  <Dropdown.Menu className="task-drop-menu">
                                    {task.priority != "High" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleSelect(task, "High")
                                        }
                                      >
                                        High
                                      </Dropdown.Item>
                                    )}
                                    {task.priority != "Medium" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleSelect(task, "Medium")
                                        }
                                      >
                                        Medium
                                      </Dropdown.Item>
                                    )}
                                    {task.priority != "Low" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleSelect(task, "Low")
                                        }
                                      >
                                        Low
                                      </Dropdown.Item>
                                    )}
                                  </Dropdown.Menu>
                                )}
                              </Dropdown>
                            </td>
                            <td className="text-end">
                              {task.status == "Complete" &&
                                task.type == "Paid" &&
                                // userInfo.role == "Admin"
                                userInfo?.Role?.permissions?.includes(
                                  "invoices/create"
                                ) && (
                                  <span
                                    key={index}
                                    className="badge badge-success light border-0 me-1 btn"
                                    title="Invoice"
                                    onClick={() => handleInvoice(task)}
                                    cursor
                                  >
                                    Invoice
                                  </span>
                                )}

                              {userInfo?.Role?.permissions?.includes(
                                "callout-services/view/:callOutTaskId"
                              ) && (
                                <span
                                  onClick={() => handleDetail(task)}
                                  style={{
                                    marginRight: "8px",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                >
                                  Detail
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <div className="dataTables_info">
                        Showing {lastIndex - recordsPage + 1} to{" "}
                        {filteredTasks.length < lastIndex
                          ? filteredTasks.length
                          : lastIndex}{" "}
                        of {filteredTasks.length} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                        id="example2_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          to="#"
                          onClick={prePage}
                        >
                          <i className="fa-solid fa-angle-left" />
                        </Link>
                        <span>
                          {number.map((n, i) => (
                            <Link
                              className={`paginate_button ${
                                currentPage === n ? "current" : ""
                              }`}
                              key={i}
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          to="#"
                          onClick={nextPage}
                        >
                          <i className="fa-solid fa-angle-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallOutTask;
